import React, {useState, useEffect} from 'react'
import {Link, NavLink, useLocation} from "react-router-dom";
import {Button, Card, Space, Table, Form, message, Input, Flex} from "antd";
import Condition from "./condition/Condition";
import ColumnsFields from "./component/ColumnsFields";
import ColumnsData from "./component/ColumnsData";
import Modal from "antd/es/modal/Modal";
import {createSelectorHook, useSelector, useDispatch} from "react-redux";
import ModalPlus from "./modal/ModalPlus";
import {CusBaseDetail, CusBaseList} from "../../../api/CusManage";
import axios from "axios";
import './demo.css'
import BaseFileUpload from "../../../components/upload/BaseFileUpload";
import invoiceCSS from "../payment/invoice/index.module.css";
import getColumnSearchProps from "../schedul/deal/component/getColumnSearchProps";


const userInfo = JSON.parse(localStorage.getItem('userInfo'));
function Accordion  (props) {
  const [formLayout, setFormLayout] = useState('inline');
  const  [myForm,querForm]  = Form.useForm();

  const [messageApi, contextHolder] = message.useMessage();
  const proInitCftList = useSelector(state => state.proInitCftList);
  const dispatch = useDispatch();
  const [] = useState(props)
  /**
   * 列表数据
   */
  const [cusBaseList, setCusBaseList] = useState()
  const [record, setRecord] = useState()
 const cusShowDetail = useSelector(state => state.cusShowDetail);
  //是否展示详情
  const [formListData, setFormListData] = useState()

  const [columns,setColumns] =useState([...ColumnsFields,  {
    title: '操作',
    dataIndex: 'operate',
    align:'center',
    width:'10rem',
    key: 'operate',
    render: (text, record, index) => (
      <>
        <Space size="middle">
          {/*<a onClick{()=>{queryDetail(record)}}>详情</a>*/}
          <a onClick={() => {
            queryDetailOrUpdate(record, true)
          }}>详情</a>
          <a onClick={() => {
            queryDetailOrUpdate(record, false)
          }}>编辑</a>
          {
            userInfo.deptId==='02' &&

            userInfo.name ===record.cusManage &&
            <NavLink to={'/manage/promanage/create'}
                     state={{
                       ...proInitCftList,
                       enterpriseName:record.enterpriseName
                     }
                     }
                     onClick={()=>{
                       dispatch({type: 'set', currentSelect:'/manage/promanage/create'})
                     }} >
              去立项
            </NavLink>
          }
        </Space>
      </>
    )
  }])


  /**
   * 打开编辑
   */
  const [open,setOpen] = useState(false);
  /**
   * 是否可编辑
   * @type {{marginBottom: string, height: string, maxWidth: string}}
   */
  const [disabled,setDisabled] = useState(false);


  // useSelector((state)=>{
  //   state.cusShowDetail
  //   }
  // )


  const searchCSSByAccordion = {
    marginBottom: '0.5rem',
    // backgroundColor: '#ffffff',
    height: '3rem',
    maxWidth: '60rem',

    // justifyContent: 'center',
    // alignItems: 'center'
  }
  const tableCSSByAccordion = {}
  const cardByAccordion = {
    width: '100%',
  }


  const columnList = columns.map(item => {
      if (item.dataIndex !== 'operate' && item.useSearch) {
        return {
          ...item,
          ...getColumnSearchProps(item.dataIndex),
        }
      } else {
        return {
          ...item
        }
      }
  })
  const CusBaseDetailHandler = (record) => {

    CusBaseDetail(record).then(response => {
        if (response.data.status === 200) {
          setFormListData(response.data.data)
        }
      }
    ).catch(error => {
      }
    )

  }

  const queryDetailOrUpdate = (record, status) => {
      setRecord(record)
      // CusBaseDetailHandler(record)
      // 更新状态
      // CusBaseDetail(record).then(res=>{
      //
      //     // setFormListData(res.data.data)
      //     // console.log(res.data.data)
      //   }
      // ).catch(error=>{
      // })
    myForm.setFieldsValue(record)
    setOpen(true)
    setDisabled(status)
      // dispatch({
      //   type: 'set', cusShowDetail: !cusShowDetail, disabled: status
      //   // formListData: response.data.data
      // })
  }



  const cusBaseAdd = (record, status) => {
    setRecord(undefined)

    setOpen(true);

  }
  const cloesWindow = ()=>{
  }

  const queryHandler = (value) => {
    // window.open('https://ant.design');
    CusBaseList(value).then(response=>{
        if(response.data.status ===200){
          setCusBaseList(response.data.data)
        }
      }
    ).catch(
      error => {

      }
    )
  }

  useEffect(() => {

    CusBaseList({}).then(response => {
      if(response.data.status===200){
        messageApi.success("客户列表查询成功",5)
        setCusBaseList(response.data.data)
      }
      }
    ).catch(
      error => {

      }
    )

  }, [])


  return (
    <>
      {contextHolder}
      <Card
        style={cardByAccordion}
      >
        <Flex style={{marginBottom:'0.5rem'}} >
          <Space direction={"horizontal"}>
            <Button  type="primary" onClick={() => {
              cusBaseAdd(null, 'add')
            }}>添加</Button>
          </Space>
        </Flex>
          <div className={'table-div-normal-project'} >
          <Table columns={columnList} dataSource={cusBaseList} pagination={false}/>
          </div>
      </Card>
      {open && <ModalPlus form={myForm} record={record} open={open} disabled={disabled} callback={(value1)=>{
        setOpen(value1)
        myForm.resetFields();
        CusBaseList({}).then(response => {
            if(response.data.status===200){
              messageApi.success("客户列表查询成功",5)
              setCusBaseList(response.data.data)
            }
          }
        ).catch(
          error => {
          }
        )
      }} />}


    </>

  )
}

export default Accordion
